export const TABLE_OPTIONS = [
  "org_cities",
  "org_states",
  "org_designations",
  "org_skills",
  "org_departments",
  "org_grade_levels",
  "org_divisions",
  "org_cost_centers",
  "org_work_locations",
  "org_roles",
  "org_assets",
  "org_leave_types",
  "org_calendar_categories",
  "fsm_products_services",
  "emp_master"
];

export const ACCEPTED_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];
